

export const CONTACT_ROUTES = [
  {
    path: "edit",
    name: "contactEdit",
    component: () =>
        import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/ContactNew"),
    children: [
      {
        path: "basic",
        name: "contactNewBasic",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/components/forms/BasicInformation")
      },
      {
        path: "user",
        name: "contactUserInfo",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/components/forms/UserInformation")
      },
      {
        path: "info",
        name: "contactNewInfo",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/components/forms/ContactsInformation")
      },
      {
        path: "personal",
        name: "contactNewPersonal",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/components/forms/PersonalInformation")
      }
    ]
  },
    {
        path: "merchantOverview",
        name: "merchantOverview",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/merchants/overviews/MerchantOverview"),
        children: [
            {
                path: "dashboard/:contactTabID?",
                name: "merchantDashboard",
                component: () =>
                    import(/* webpackChunkName: "contacts" */ "@/modules/contacts/merchants/overviews/MerchantDashboard")
            },
        ]
    },
  {
    path: "overview",
    name: "contactOverview",
    component: () =>
        import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/ContactOverview"),
    children: [
      {
        path: "dashboard/:contactTabID?",
        name: "contactDashboard",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactDashboard")
      },

      {
        path: "documents",
        name: "contactDocuments",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactDocumentsUploads")
      },

      {
        path: "photos",
        name: "contactPhotos",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactPhotosUploads")
      },
      {
        path: "comments",
        name: "contactComments",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactComments")
      },
      {
        path: "inspection",
        name: "contactInspection",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactInspection")
      },
      {
        path: "issue",
        name: "contactIssues",
        component: () =>
            import(/* webpackChunkName: "issues" */ "@/modules/issues/components/ui/OverviewIssues")
      },
      {
        path: "renewal",
        name: "contactRenewal",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactRenewal")
      },
      {
        path: "assignment",
        name: "contactAssignment",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactAssignment")
      },
      {
        path: "location",
        name: "contactLocation",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactLocation")
      },
      {
        path: "notification",
        name: "contactNotification",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactNotification")
      },
      {
        path: "userManagment",
        name: "contactUserManagement",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactUserManagement")
      }
    ]
  },
  {
    path: "overviewCustomer",
    name: "customerOverview",
    component: () =>
        import(/* webpackChunkName: "contacts" */ "@/modules/contacts/customers/overviews/CustomerOverview"),
    children: [
      {
        path: "dashboard/:contactTabID?",
        name: "customerDashboard",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/customers/overviews/CustomerDashboard")
      },

      {
        path: "documents",
        name: "contactDocuments",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactDocumentsUploads")
      },

      {
        path: "photos",
        name: "contactPhotos",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactPhotosUploads")
      },
      {
        path: "comments",
        name: "contactComments",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactComments")
      },
      {
        path: "inspection",
        name: "contactInspection",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactInspection")
      },
      {
        path: "issue",
        name: "contactIssues",
        component: () =>
            import(/* webpackChunkName: "issues" */ "@/modules/issues/components/ui/OverviewIssues")
      },
      {
        path: "renewal",
        name: "contactRenewal",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactRenewal")
      },
      {
        path: "assignment",
        name: "contactAssignment",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactAssignment")
      },
      {
        path: "location",
        name: "contactLocation",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactLocation")
      },
      {
        path: "inventories",
        name: "customerInventories",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/customers/overviews/CustomerInventories")
      },
      {
        path:"vehicleVisitations",
        name: "customerVisitation",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/customers/overviews/CustomerVisitation")
      },
      {
        path: "userManagment",
        name: "contactUserManagement",
        component: () =>
            import(/* webpackChunkName: "contacts" */ "@/modules/contacts/layouts/overviews/ContactUserManagement")
      }
    ]
  },
  {
    path: "customerDetailsForm",
    name: "customerDetailsForm",
    component: () =>
        import(/* webpackChunkName: "contacts" */ "@/modules/contacts/customers/components/forms/CustomerDetailsForm")
  },
  {
    path: "merchantDetailsForm",
    name: "merchantDetailsForm",
    component: () =>
        import(/* webpackChunkName: "contacts" */ "@/modules/contacts/merchants/components/forms/MerchantDetailsForm")
  }
];
